// スムーズスクロール機能
document.addEventListener('DOMContentLoaded', function() {
  // すべてのアンカーリンクを取得
  const anchorLinks = document.querySelectorAll('a[href*="#"]');

  anchorLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const href = this.getAttribute('href');

      // ハッシュが含まれているか確認
      if (href && href.includes('#')) {
        const url = new URL(href, window.location.origin);
        const hash = url.hash;
        const pathname = url.pathname;

        // ハッシュが存在する場合
        if (hash) {
          // 同じページ内の場合
          if (pathname === window.location.pathname || href.startsWith('#')) {
            e.preventDefault();
            const targetId = hash.substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
              targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });

              // URLのハッシュを更新（履歴に追加せず）
              if (history.replaceState) {
                history.replaceState(null, null, hash);
              }
            }
          }
          // 別ページの場合は通常の遷移（ブラウザがハッシュ位置にジャンプ）
        }
      }
    });
  });

  // ページ読み込み時にハッシュがある場合、そこにスクロール
  if (window.location.hash) {
    setTimeout(() => {
      const targetId = window.location.hash.substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
  }
});
